
import { debugActive } from "./Variant.js";
import { concat } from "./fable_modules/fable-library-js.5.0.0-rc.2/String.js";

export function redirectUri() {
    if (debugActive) {
        return "http://localhost:8080/#/";
    }
    else {
        return concat(window.location.origin, ..."/#/");
    }
}

